<template>
  <div class="card h-100">
    <div class="card-header py-2">
      <h6 class="mb-0">{{ title }}</h6>
    </div>
    <div class="card-body">
      <div
        v-if="fixed"
        :style="{ height: height + 'px' }"
        class="widget-chart"
      >
        <slot />
      </div>
      <slot v-else />
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetCard",
  props: {
    title: { type: String, default: "" },
    height: { type: Number, default: 300 },
    fixed: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.widget-chart {
  position: relative;
  width: 100%;
}
</style>
